import { useEffect, useRef } from 'react';

export const useScheduler = (action, searchInterval) => {
	const timer = useRef(null);

	useEffect(() => {
		action();
		timer.current = setInterval(() => {
			action();
		}, searchInterval);

		return () => {
			clearInterval(timer.current);
		};
	}, [action, searchInterval]);
};
